export default "__VITE_ASSET__e79a9624__"